<template>
  <div id="app">
    <transition name="fade">
      <router-view></router-view>
    </transition>
    <notifications position="top right" />
  </div>
</template>

<script>
import Sidebar from './components/menu/Sidebar.vue';
import Header from './components/menu/Header.vue';

export default {
  name: 'app',
  components: {
    'page-sidebar': Sidebar,
    'page-header': Header
  }
}
</script>
<style lang="scss">
  @import "assets/app";
  $namespace: 'xmx';

  $default-color: #555;
  $primary-color: #d09f23;

  @import '~vue2-datepicker/scss/index.scss';

  .xmx-datepicker {
    width: 100%;
  }

  .xmx-datepicker-popup {
    z-index: 30001
  }

  .xmx-input {
    box-shadow: none;
    border-color: #c2cad8;
    &:disabled {
      border-color: #c2cad8;
      background-color: #eef1f5;
      color: $default-color;
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition-property: opacity;
    transition-duration: .3s;
  }

  .fade-enter-active {
    //transition-delay: .3s;
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }
  .notifications {
    top:80px !important;
    z-index: 10051 !important;
  }
  .vue-notification {
    background: #67cd85 !important;
    border-left: 5px solid #41a85e !important;
  }

  .vue-notification.error {
    background: #e64c42 !important;
    border-left: 5px solid #b82f24 !important;
  }

  .vue-notification.warning {
    background: #ffb648 !important;
    border-left: 5px solid #f48908 !important;
  }



  @media (max-width: 767px) {
    .dropdown-backdrop {
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// App.vue?5a5d6562